export default __webpack_public_path__ + "images/49d215df00dfcbcb44a5029543219289.png";